import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import SelectController from './controllers/select-controller';
import PostsController from './controllers/posts-controller';
import FileUploadController from './controllers/file-upload-controller';
import ToggleController from './controllers/toggle-controller';
import MapController from './controllers/map-controller';

require('./navigation');
require('./animations');
require('./lightbox');

const application = Application.start();

application.register('axios-form', AxiosFormController);
application.register('modal', ModalController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('select', SelectController);
application.register('posts', PostsController);
application.register('file-upload', FileUploadController)
application.register('toggle', ToggleController);
application.register('map', MapController);